import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { CheckCircle } from "lucide-react";
import { useParams } from "react-router-dom";

export default function Confirm() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("checking");
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;
    (async () => {
      try {
        const r = await api.get(`/public/confirm/${token}`);
        setStatus("ok");
        const slug = r.data.redirect_slug;
        toast.success("Email confirmed!");
        setTimeout(() => navigate(`/lm/${slug}/delivery`), 800);
      } catch (e) {
        setStatus("error");
      }
    })();
  }, [token, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-6 dot-grid">
      <div className="card-brutal !p-10 max-w-md w-full text-center" data-testid="confirm-status">
        {status === "checking" && (
          <>
            <div className="font-display font-black text-3xl mb-2">Confirming…</div>
            <p className="text-zinc-600">Verifying your email.</p>
          </>
        )}
        {status === "ok" && (
          <>
            <div className="w-14 h-14 mx-auto bg-[#FF4F00] border-2 border-black flex items-center justify-center mb-4"><CheckCircle className="text-white" size={28} /></div>
            <div className="font-display font-black text-3xl mb-2">Confirmed!</div>
            <p className="text-zinc-600">Redirecting to your content…</p>
          </>
        )}
        {status === "error" && (
          <>
            <div className="font-display font-black text-3xl mb-2">Hmm…</div>
            <p className="text-zinc-600 mb-4">This confirmation link is invalid or expired.</p>
          </>
        )}
      </div>
    </div>
  );
}
